import { create } from 'zustand'
import { Feed } from '../types/Feed'

type FeedStore = {
  mute: boolean
  currentFeedActiveIndex: number
  currentStep: number
  feed: Feed[]
  fetchCount: number
  resetFeed: () => void
  setCurrentFeedActiveIndex: (index: number) => void
  setCurrentStep: (step: number) => void
  setFeed: (feed: Feed[]) => void
  setShowMuteIcon: (show: boolean) => void
  setStepperVisible: (stepperVisible: boolean) => void
  stepperVisible: boolean
  showMuteIcon: boolean
  toggleMute: () => void
}

export const useFeedStore = create<FeedStore>((set, get) => ({
  mute: true,
  currentFeedActiveIndex: 0,
  currentStep: 1,
  feed: [],
  fetchCount: 0,
  resetFeed: () => set({ feed: [], currentFeedActiveIndex: 0, fetchCount: 0 }),
  setCurrentFeedActiveIndex: (index: number) =>
    set({ currentFeedActiveIndex: index }),
  setCurrentStep: (step: number) => set({ currentStep: step }),
  setFeed: (feed: Feed[]) => set({ feed, fetchCount: get().fetchCount + 1 }),
  setShowMuteIcon: (show: boolean) => set({ showMuteIcon: show }),
  setStepperVisible: (stepperVisible: boolean) => set({ stepperVisible }),
  showMuteIcon: true,
  stepperVisible: false,
  toggleMute: () => set((state) => ({ mute: !state.mute })),
}))
